module.exports = __webpack_public_path__ + "static/media/downloadCode.9cf7e2b4.gif";